import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromInvoice from '../../core/reducers/invoice.reducer';
import * as actionInvoice from '../../core/actions/invoice.actions';
import { Pagination } from '../../shared/models/pagination';
import { LazyLoadEvent } from 'primeng/api';
@Component({
  selector: 'app-facture-entree',
  templateUrl: './facture-entree.component.html',
  styleUrls: ['./facture-entree.component.scss']
})
export class FactureEntreeComponent implements OnInit {
  invoices = [
  ];
  pagination: Pagination;
  lastPagination: string = '';

  constructor(private store: Store<any>) { }

  ngOnInit() {
    this.store.select(fromInvoice.selectInvoices).subscribe(st => {this.invoices = st;});
    this.store.select(fromInvoice.selectInvoicePagination).subscribe(c => {console.log(c); this.pagination = c;});

  }
  loadLazy(event: LazyLoadEvent) {        
    if (JSON.stringify(event) !== this.lastPagination ) {
      this.store.dispatch(new actionInvoice.LoadInvoicesAction(event.sortField,event.sortOrder, event.filters, event.first, event.rows, false));
      console.log('load lazy', event);
      this.lastPagination = JSON.stringify(event);    
    }        
  }  
  addInvoice() {
  	console.log('add invoice');

    this.store.dispatch(new actionInvoice.AddInvoiceAction(4));
  }
  openInvoice(id) {
     this.store.dispatch(new actionInvoice.OpenTabAction(id)); 
  }
}
